// Return array from
export const from = (target: string) => Array.from<HTMLElement>(document.querySelectorAll(target))
// Run function on each target
export const each = (target: string, callable: (item: HTMLElement) => void) => from(target).forEach(item => callable(item))
// Check if element exists
export const elementExists = (targetId: string) => document.getElementById(targetId) !== null
// Get element by Id
export const elementById = (targetId: string) => document.getElementById(targetId)
// set element styling
export const css = (element: HTMLElement, style: object) => {
    for (const property in style) {
        // @ts-ignore
        element.style[property] = style[property];
    }
}
// check if values match
export const valuesMatch = (thisValue, matchesThis) => thisValue === matchesThis
// check if is "" or null
export const isEmpty = (subject) => (subject === "" || subject === null)
export const isNotEmpty = (subject) => (subject !== "" && subject !== null)
// check if array is empty
export const isEmptyArray = (arr: Array<string|undefined>) => arr.length === 0
// check if array is not empty
export const isNotEmptyArray = (arr: Array<string>) => arr.length !== 0
